import {DigitalAssetVisual} from '@cohort/components-xps/components/DigitalAssetVisual';
import {NftTitleBlock} from '@cohort/components-xps/components/NftTitleBlock';
import BuyButton from '@cohort/wallet/components/store/BuyButton';
import PriceLabel from '@cohort/wallet/components/store/PriceLabel';
import {Stepper} from '@cohort/wallet/components/store/Stepper';
import {Transition} from '@cohort/wallet/components/transitions/Transition';
import useStoreContext from '@cohort/wallet/hooks/useStoreContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import React from 'react';
import {useTranslation} from 'react-i18next';

type StoreLeftPanelProps = {
  withBuyButton?: boolean;
};

const StoreLeftPanel: React.FC<StoreLeftPanelProps> = ({withBuyButton}) => {
  const {t} = useTranslation('layouts', {keyPrefix: 'store.storeDekstopLayout'});
  const {campaign, buyingStep, price, setCurrency} = useStoreContext();
  const {accentColor, hasDarkBg} = useThemeContext();

  return (
    <div className="no-scrollbar h-full overflow-y-auto">
      <div className="flex h-full flex-col items-center justify-between space-y-5">
        <DigitalAssetVisual
          digitalAssetImageFileKey={campaign.collection.imageFileKey}
          animationFileKey={campaign.collection.animationFileKey}
        />

        <div className="w-full space-y-5">
          <NftTitleBlock
            hasDarkBg={hasDarkBg}
            pretitle={t('typeOfProduct')}
            title={campaign.collection.name}
            subtitle={
              price === null ? (
                t('free')
              ) : (
                <PriceLabel
                  price={price}
                  prices={campaign.store.prices}
                  setCurrency={setCurrency}
                />
              )
            }
            additionnalCssStyleOnAccent={{color: accentColor}}
          />

          {withBuyButton ? (
            <BuyButton />
          ) : (
            <Transition enterFrom="left" appear>
              <Stepper step={buyingStep.current} total={buyingStep.total} />
            </Transition>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreLeftPanel;
